export default __webpack_public_path__ + "static/media/ma.4d3a6f5c.svg";